import React, { useState } from "react";

import { Button } from "@amphore-dev/amphore-lib";
import { useFormikContext } from "formik";
import { t } from "i18next";

import { TReportFormValues } from "@/types";

import { useReportForm } from "./ReportForm";
import { ReportSubmitModal } from "./ReportSubmitModal";

const formatTime = (_time: number) => {
	const time = _time.toFixed(2);
	return time.endsWith("0") ? _time.toFixed(1) : time;
};

const calcDaysValues = (values: TReportFormValues) => {
	let real = 0;
	let calculated = 0;
	values.projects.forEach((element) => {
		real += parseFloat(element.initialDays || "0");
		if (element.selected) {
			calculated += parseFloat(element.days || "0");
		}
	});
	return { real, calculated };
};

export const ReportSummaryBar: React.FC = () => {
	const { reportId, existingReport } = useReportForm();
	const { values } = useFormikContext<TReportFormValues>();
	const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);

	const { real, calculated } = calcDaysValues(values);

	return (
		<div className="mt-4 flex items-center justify-between gap-4 border-t pt-4">
			<div className="flex gap-4 text-sm text-neutral-600">
				{!!real && (
					<div>
						{t("reports.initialDuration")}:{" "}
						<span className="font-bold">
							{t("reports.days.count", {
								count: real,
								value: formatTime(real),
							})}
						</span>
					</div>
				)}
				<div>
					{t(
						real
							? "reports.calculatedDuration"
							: "reports.totalDuration"
					)}
					:{" "}
					<span className="font-bold">
						{t("reports.days.count", {
							count: calculated,
							value: formatTime(calculated),
						})}
					</span>
				</div>
			</div>
			<Button
				color="primary"
				onClick={() => setIsSubmitModalOpen(true)}
				disabled={!values.projects.length}
			>
				{t("reports.generateCTA")}
			</Button>
			<ReportSubmitModal
				isOpen={isSubmitModalOpen}
				onClose={() => setIsSubmitModalOpen(false)}
				reportId={reportId}
				existingReport={existingReport}
			/>
		</div>
	);
};
